
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import uiService from "../../services/uiService";
import errorService from "../../services/errorService";

export default Vue.extend({
  data() {
    return {
      showDetailError: false,
      errorService,
      value: "",
      newServerName: "",
      binding: {},
      overtime: false,
    };
  },
  computed: {
    showNotiSystem() {
      if (this.binding.authenAuthenInfo && this.binding.authenAuthenInfo.access_token_verify_error) {
        const {showNotiSystem} = this.errorService.normalize(this.binding.authenAuthenInfo.access_token_verify_error)
        if (showNotiSystem) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    optionNotification() {
      const options = {
        attrs: {
          class: 'noti-bottom'
        },
        content: {
          title: () => {
            return this.$t('VERIFY_CURRENT_SESSION.CONNECTIVITY_LOST');
          },
          html: () => {
            if (this.binding.authenAuthenInfo) {
              return this.errorService.normalize(this.binding.authenAuthenInfo.access_token_verify_error).err;
            }
            return this.$t('VERIFY_CURRENT_SESSION.SOMETHING_WENT_WRONG');
          },
        },
      };
      return options;
    },
  },
  async created() {
    msDataProvider.watchData(
        "authenAuthenInfo",
        (value) => {
          if (!value.access_token_verifying) {
            this.$router.push("/");
          }
        },
        this
    );

    try {
      this.value = await msDataProvider.executeCommand(
          "backendServerNameGetCurrentValue"
      );
    } catch (e) {
      this.error = e;
    }

    msDataProvider.bindDataMany(
        ["authenAuthenInfo", "backendServerNameCurrentValue"],
        this.binding,
        this,
        null,
        this
    );

    const self = this;
    setTimeout(() => {
      self.overtime = true;
    }, 8000);
  },
  methods: {
    changeBackendServerName() {
      uiService.executeCommand("backendServerNameShow", undefined, true);
    },
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
